// extracted by mini-css-extract-plugin
module.exports = {"selector":"simple-sidebar-popover_selector__U13gt","selectorContent":"simple-sidebar-popover_selectorContent__MsVkm"};